// @flow
import * as React from 'react';
import {useState} from 'react';

import Button from 'sail/Button';
import Dialog, {DialogContent, DialogFooter, DialogHeader} from 'sail/Dialog';
import {Body, BodyAlt} from 'sail/Text';
import {TextInput} from 'sail/Input';
import Group from 'sail/Group';
import Checkbox from 'sail/Checkbox';
import {useDiagramGenerator} from 'docs/data/diagram';

type AddEventProps = {|
  event: string,
  setEvent: (string) => void,
|};

const AddEvent = ({event, setEvent}: AddEventProps) => (
  <Group spacing={4}>
    <label htmlFor="edgeEvent">
      <BodyAlt>Webhook event</BodyAlt>
    </label>
    <TextInput id="edgeEvent" onChange={setEvent} value={event} />
  </Group>
);

type AddStyleProps = {|
  checked: boolean,
  setChecked: (any) => void,
|};

const AddStyle = ({checked, setChecked}: AddStyleProps) => (
  <Checkbox
    checked={checked}
    onChange={setChecked}
    label="Is response?"
    description="Check this box if this edge represents a response coming from part of a system (rather than a request). Will render as a dashed line."
  />
);

export const AddEdge = () => {
  const {type, addEdgeContent} = useDiagramGenerator();
  const [label, setLabel] = useState('');
  const [event, setEvent] = useState('');
  const [error, setError] = useState('');
  const [dashed, setDashed] = useState(false);

  return (
    <Dialog width="medium">
      <DialogHeader title="Add edge content" />
      <DialogContent padding={20}>
        <Group spacing={20}>
          <Group spacing={4}>
            <label htmlFor="edgeLabel">
              <BodyAlt>Edge label</BodyAlt>
            </label>
            <TextInput
              id="edgeLabel"
              onChange={setLabel}
              value={label}
              invalid={!!error}
              placeholder={
                type === 'sequence'
                  ? 'Add a label to the edge'
                  : 'Add an optional label to the edge'
              }
            />
            {error ? <Body>{error}</Body> : ''}
          </Group>
          {type === 'sequence' && (
            <AddEvent event={event} setEvent={setEvent} />
          )}
          {type === 'sequence' && (
            <AddStyle
              checked={dashed}
              setChecked={() => {
                setDashed(!dashed);
              }}
            />
          )}
        </Group>
      </DialogContent>
      <DialogFooter
        end={
          <Button
            label="Add"
            onClick={() => {
              if (type === 'sequence' && !label) {
                setError('A label is required for sequence diagram edges');
                setTimeout(() => {
                  setError('');
                }, 5000);
              } else {
                addEdgeContent({
                  label,
                  event,
                  style: dashed ? 'dashed' : 'default',
                });
              }
            }}
          />
        }
      />
    </Dialog>
  );
};
